import { type CSSObject } from '@emotion/react';
import { useTheme } from '../../../theme';
import { formControlClasses } from '@mui/material/FormControl';

type UseDropdownStylesProps = {
  width?: CSSObject['width'];
  padding?: CSSObject['padding'];
  maxHeight?: CSSObject['maxHeight'];
};

type UseDropdownStylesReturnType = Record<
  'search' | 'container' | 'menu',
  CSSObject
>;

export const useDropdownStyles = ({
  width = '320px',
  maxHeight,
}: UseDropdownStylesProps): UseDropdownStylesReturnType => {
  const theme = useTheme();

  return {
    container: {
      maxHeight,
      width,
      backgroundColor: theme.menu.background.default,
      borderWidth: 1,
      borderColor: theme.menu.background.border,
      borderRadius: theme.shape.radius8,
      borderStyle: 'solid',
      boxShadow: theme.shadows[2],
      backdropFilter: theme.backdropFilter.xlarge,
    },
    menu: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      overflowY: 'auto',
      overflowX: 'hidden',
      '& > *': {
        flexShrink: '0 !important',
      },
    },
    search: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      padding: theme.spacing(1, 3, 3, 3),

      [`.${formControlClasses.root}`]: {
        width: '100%',
      },
    },
  };
};
